var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 136.36,
    height: 21,
    viewBox: "0 0 136.36 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DevsMore_Logo_white",
    transform: "translate(-0.01)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52419",
    "data-name": "Path 52419",
    d: "M68.43,19.45a7.727,7.727,0,0,1,7.773,8.9H63.7a5.052,5.052,0,0,0,9.428,1.418l2.6,1.154a7.865,7.865,0,0,1-7.151,4.227,7.847,7.847,0,1,1-.15-15.693Zm4.639,6.475a4.736,4.736,0,0,0-9.278,0Z",
    transform: "translate(-44.044 -14.145)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52420",
    "data-name": "Path 52420",
    d: "M173.289,32.624c1.98,0,3.281-.886,3.281-2.04,0-3.488-9.251-.649-9.251-6.562,0-2.629,2.542-4.582,5.97-4.582s5.733,1.685,6.177,4.285l-3.1.649a2.766,2.766,0,0,0-3.074-2.425c-1.743,0-2.836.769-2.836,1.92,0,3.368,9.251.562,9.251,6.649,0,2.659-2.806,4.609-6.412,4.609s-5.94-1.685-6.412-4.285l3.1-.649c.265,1.565,1.418,2.425,3.311,2.425Z",
    transform: "translate(-121.36 -14.138)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52421",
    "data-name": "Path 52421",
    d: "M251.44,20.827h3.1V24.52c.8-2.422,2.542-3.99,4.816-3.99,2.452,0,4.285,1.685,4.966,4.2a5.252,5.252,0,0,1,5.024-4.2c3.134,0,5.321,2.689,5.321,6.385v9.014h-3.1V27.386c0-2.335-1.478-4.02-3.338-4.02a3.7,3.7,0,0,0-3.635,4.02v8.542h-3.1V27.386c0-2.335-1.448-4.02-3.311-4.02a3.7,3.7,0,0,0-3.635,4.02v8.542h-3.1v-15.1Z",
    transform: "translate(-182.858 -14.931)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52422",
    "data-name": "Path 52422",
    d: "M351.57,19.45a7.848,7.848,0,1,1-8.01,7.86A7.782,7.782,0,0,1,351.57,19.45Zm0,12.826a4.779,4.779,0,0,0,4.816-4.966,4.82,4.82,0,1,0-9.633,0A4.781,4.781,0,0,0,351.57,32.276Z",
    transform: "translate(-249.855 -14.145)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52423",
    "data-name": "Path 52423",
    d: "M409.1,20.867h3.1v3.99c1.064-3.783,3.458-4.7,5.91-4.107v2.956c-3.311-.916-5.91.826-5.91,3.723v8.542h-3.1Z",
    transform: "translate(-297.52 -14.971)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52424",
    "data-name": "Path 52424",
    d: "M450.32,19.45a7.727,7.727,0,0,1,7.773,8.9h-12.5a5.052,5.052,0,0,0,9.428,1.418l2.6,1.154a7.865,7.865,0,0,1-7.151,4.227,7.847,7.847,0,1,1-.15-15.693Zm4.642,6.475a4.736,4.736,0,0,0-9.278,0Z",
    transform: "translate(-321.782 -14.145)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52425",
    "data-name": "Path 52425",
    d: "M11.816,8.084V0H14.9V20.738H11.816v-2.13A6.018,6.018,0,0,1,6.8,21C2.849,21,.01,17.621.01,13.347S2.849,5.695,6.8,5.695a6.057,6.057,0,0,1,5.021,2.392ZM10.559,16.9a5.119,5.119,0,0,0,1.255-3.556c0-2.809-1.855-4.934-4.454-4.934A4.274,4.274,0,0,0,4.1,9.818a5.043,5.043,0,0,0-1.255,3.526A5.114,5.114,0,0,0,4.1,16.9,4.157,4.157,0,0,0,7.36,18.275a4.033,4.033,0,0,0,3.2-1.375Z",
    transform: "translate(0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31507",
    "data-name": "Rectangle 31507",
    width: 8.626,
    height: 3,
    transform: "translate(34.453 17.997)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52426",
    "data-name": "Path 52426",
    d: "M121.281,8.324,117.065,2.28H113.47l7.811,10.778L129.095,2.28h-3.6Z",
    transform: "translate(-82.516 -1.658)",
    fill: "#fd9a98"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5191f13bc3f6a796e0695813203f2b91.svg";
export { ForwardRef as ReactComponent };